// You can customize the template with the help of this file

//Template config options
const themeConfig = {
  app: {
    appName: 'HR System',
    appLogoImage: require('@src/assets/images/logo/logo.svg').default
  },
  data: {
   //API:"http://174.142.60.74:8056/"
   API:"https://aljazeera.hr.api.crm1max.com/"
  // API:"https://localhost:44399/"
    //  API:"http://emplygate.imaxjsarp.com:8054/"
  // API:"https://174.142.60.74:8013/"
   // API:"http://192.168.43.156:8082/"
   //  API:"https://hrapi.maxcrm.org/"
  // API:"https://Aljazeera.Hr.API.maxcrm.org/"
  //  API:"https://api.dycement.com:5443/"
  },
  layout: {
    isRTL: true,
    skin: 'light', // light, dark, bordered, semi-dark
    type: 'vertical', // vertical, horizontal
    contentWidth: 'boxed', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: true,
    scrollTop: true, // Enable scroll to top button
    toastPosition: 'top-right' // top-left, top-center, top-right, bottom-left, bottom-center, bottom-right
  }
}

export default themeConfig
